export const getEmployeeId = (id, employmentType) => {
  try {
    if (id === undefined || id === null) {
      return "-";
    }
    // Pad the id with zeros to make it 3 digits
    const paddedId = id.toString().padStart(3, "0");

    switch (employmentType) {
      case 1:
        return `EMP-${paddedId}`;
      case 2:
        return `PER-${paddedId}`;
      case 3:
        return `CON-${paddedId}`;
        case 4:
          return  `REF-${paddedId}`;
      default:
        return `EMP-${paddedId}`;
    }
  } catch (error) {
    console.error("Error generating employee ID:", error);
    return null;
  }
};
